module.exports = __webpack_public_path__ + "static/media/m14tj823.b8704817.png";